import { render, staticRenderFns } from "./qualityTaskDetail.vue?vue&type=template&id=07a4a76f&scoped=true"
import script from "./qualityTaskDetail.vue?vue&type=script&lang=js"
export * from "./qualityTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./qualityTaskDetail.vue?vue&type=style&index=0&id=07a4a76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4a76f",
  null
  
)

export default component.exports